export function hasAnySubstring(str, arr) {
  let res

  for (var i = 0; i < arr.length; i++) {
    res = str.indexOf(arr[i]) > -1
    if (res) return res
  }

  return res
}

export function addNativeEvent(el, type, handler) {
  el.attachEvent ? el.attachEvent('on' + type, handler) : el.addEventListener(type, handler)
}

export function removeNativeEvent(el, type, handler) {
  el.detachEvent ? el.detachEvent('on' + type, handler) : el.removeEventListener(type, handler)
}

export function deferJquery(f1, f2, time = 0, timeout = 1000) {
  if (jQueryObject()) {
    debugLog('Found jquery')

    // try to load after other js on the page
    setTimeout(f1, 200)

    // f1();
  } else {
    if (time > timeout) {
      debugLog('No jquery - gave up waiting')
      f2()
    } else {
      debugLog('No jquery - waiting 50ms')
      setTimeout(function() { deferJquery(f1, f2, time + 50, timeout) }, 50)
    }
  }
}

export function jQueryObject() {
  // Hack for sites built with landing page generator. It uses noConflict jquery in this way:
  // lp.jQuery = jQuery.noConflict( true );
  // After that we can't handle `lp.jQuery(form).submit` event.
  return (window.lp && window.lp.jQuery) || window.jQuery
}

function getQueryParameters (str) {
  return (str || document.location.search)
    .replace(/(^\?)/, '')
    .split('&')
    .reduce((memo, el) => {
      let arr = el.split('=')
      memo[arr[0]] = arr[1]
      return memo
    }, {})
}

export function debugLog() {
  if (process.env.NODE_ENV === 'dev' || getQueryParameters().jdbg) {
    console.info.call(null, 'JENSEN DEBUG:', ...Array.from(arguments))
  }
}



// WEBPACK FOOTER //
// ./app/common/utils.js